import { GENERAL_FORM_FIELDS, FUNDING_CONFIG_FORM_FIELDS } from '../../constants/merchant/general-form';

export type formInputFieldName = string | GENERAL_FORM_FIELDS | FUNDING_CONFIG_FORM_FIELDS;

export enum HELPERS_ROUTES {
    BUSINESS_TYPES = 'businessTypes',
    ECOMMERCE_PLATFORM = 'ecommercePlatforms',
    COUNTRIES = 'countries',
    STATES = 'states',
    INDUSTRIES = 'industries',
    MCC = 'mcc'
}

export type PickerData = {
    value: string | number;
    label: string;
}

export type ErrorMessagePosition = {
    top?: number | string;
    left?: number | string;
    right?: number | string;
    bottom?: number | string;
}

export enum InputType {
    Text = 'text',
    Number = 'number',
    Select = 'select',
    MultiSelect = 'multiSelect',
    Phone = 'phone',
    Date = 'date',
    DateRange = 'date-range',
    Description = 'description',
    Img = 'img',
    Editor = 'editor',
    Website = 'website'
}
